<template>
    <div class="addShelf_wrap">
        <el-input v-model="shelfName" placeholder="书架名称" @keyup.enter="submit"></el-input>
        <div class="" style="text-align: center;padding-top: 15px;">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="submit">确认</el-button>
        </div>
    </div>
</template>

<script>
import { getUserInfo } from "@/common/utils/localStorage.js";
import { createShelf, updateShelf } from "@/api/bookshelf";

export default {
    props: ['type', 'data'],
    data(){
        return {
            bookData:'',
            shelfName: '',
        }
    },
    mounted(){
        let vm = this;
        if(vm.type == '1'){
            vm.bookData = vm.data;
            vm.shelfName = vm.data.shelfName;
        }
    },
    methods:{
        submit(){
            let vm = this;
            if(vm.shelfName!=''){
                if(vm.type == '0'){
                    createShelf({
                        creatorId: getUserInfo().pkid,
                        shelfName: vm.shelfName,
                        visitType: 1,
                        visitUrl: window.location.href,
                        visitFunc: '',
                    }).then(res => {
                        if(res.status){
                            vm.$message({
                                message: "新增成功！",
                                type: "success"
                            });
                            vm.$emit('submit', res.data);
                        }

                    }).catch(err => {

                    });
                }else{
                    updateShelf({
                        pkid: vm.bookData.pkid,
                        creatorId: getUserInfo().pkid,
                        shelfName: vm.shelfName,
                        visitType: 1,
                        visitUrl: window.location.href,
                        visitFunc: '',
                    }).then(res => {
                        if(res.status){
                            vm.$message({
                                message: "修改成功！",
                                type: "success"
                            })
                            vm.$emit('submit', res.data);
                        }

                    }).catch(err => {

                    });
                }
            }else{
                vm.$message({
                    message: '请输入书架名称！',
                    type: "error"
                });
            }
        },
        cancel(){
            let vm = this;
            vm.$emit('close');
        }
    }
}
</script>

<style lang="scss">
.addShelf_wrap{
    padding:20px 10px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/addShelf/editorTitle.vue